export default "__VITE_ASSET__DbCMtPen__"